/**
 * Where the game server is. In a development build it is the same machine on the server's own port
 * (so a phone on the local network reaches the server through the same host name as the page); in a
 * production build it must be named (`VITE_GAME_SERVER_URL`), and without it there is no online play.
 */
export function gameServerUrl(
  env: { DEV: boolean; VITE_GAME_SERVER_URL?: string | undefined } = import.meta.env,
  host: string = typeof location === 'undefined' ? 'localhost' : location.hostname,
): string | null {
  const named = env.VITE_GAME_SERVER_URL?.trim();
  if (named) return named;
  return env.DEV ? `ws://${host}:2567` : null;
}
